import { ThemeProvider } from '@emotion/react';
import { useEffect, useState } from 'react';
import { ToolLoader } from 'shared/components';
import defaultTheme from 'shared/defaultTheme';
import { getToolSettings, getInterestRates } from '../helpers';
import { OverviewContainer, BrokenLayout } from './Layout';
import Header from './Header';
import FilterView from './FilterView';
import Table from "./Table";
import { ConversieButtons } from "shared/conversie";
import LeadFormWithHooks from "shared/conversie/LeadFormWithHooks";
import {getParamsFromState} from "shared/helpers";

const App = () => {
  // Config
  const [theme, setTheme] = useState(defaultTheme);
  const [loading, setLoading] = useState(true);
  const [broken, setBroken] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  // Data
  const [nhg, setNhg] = useState(true);
  const [ltv, setLtv] = useState(100);
  const [output, setOutput] = useState(null);

  // Configure tool
  useEffect(() => {
    async function configure() {
      const settings = await getToolSettings(setBroken);
      const { renteTop5DefaultNhg, renteTop5DefaultLtv, backgroundColor } = settings;

      setTheme(theme => ({ ...theme, ...settings, cardColor: backgroundColor }));
      setNhg(renteTop5DefaultNhg);
      setLtv(renteTop5DefaultLtv);
      setLoading(false);
    }

    configure();
  }, []);

  // Get data when parameters change
  useEffect(() => {
    if (!loading) getInterestRates(nhg, ltv, setBroken, setOutput);
  }, [loading, nhg, ltv]);

  if (loading) return <ToolLoader />;
  if (broken) return  <BrokenLayout />;

  return (
    <ThemeProvider theme={theme}>
      <OverviewContainer>
        {showFilters ? (
          <FilterView {...{ nhg, setNhg, ltv, setLtv, setShowFilters }} />
        ) : (
          <>
            <Header {...{ nhg, ltv, setShowFilters }} />
            {output && <Table {...{ output }} />}
            <ConversieButtons
              app="zelfreflectie"
              settings={theme}
              LeadForm={props => <LeadFormWithHooks {...props} toolData={{ nhg, ltv }} />}
              urlLeadFormParams={getParamsFromState({ nhg, ltv }, ['nhg', 'ltv'])}
              css={{ marginTop: '16px' }}
            />
          </>
        )}
      </OverviewContainer>
    </ThemeProvider>
  );
};

export default App;
